import React from 'react'
import Link from 'react-router/lib/Link'
import Panel from 'react-bootstrap/lib/Panel'
import ListGroup from 'react-bootstrap/lib/ListGroup'

const Menu = () => (
  <Panel header="Settings">
    <ListGroup fill>
      <Link to="/settings/semester" className="list-group-item" activeClassName="active">Semester Settings</Link>
    </ListGroup>
  </Panel>
)

export default Menu



// WEBPACK FOOTER //
// ./src/containers/Settings/menu.js